import { Col, FormGroup, Form, Row } from "react-bootstrap";
import {ErrorText} from "../../../../../@ui/ErrorText";
import FileUploader from "../../../../../@ui/FileUploader";

interface TranslinkImportFieldsProps {
  setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void;
  errors: any;
  busArchiveTouched: boolean;
  setBusArchiveTouched: (touched: boolean) => void;
  railArchiveTouched: boolean;
  setRailArchiveTouched: (touched: boolean) => void;
  metroArchiveTouched: boolean;
  setMetroArchiveTouched: (touched: boolean) => void;
}

const TranslinkImportFields = ({
  setFieldValue,
  errors,
  busArchiveTouched,
  setBusArchiveTouched,
  railArchiveTouched,
  setRailArchiveTouched,
  metroArchiveTouched,
  setMetroArchiveTouched,
}: TranslinkImportFieldsProps) => {
  return (
    <>
      <Row className="justify-content-center">
        <Col className="col-md-10">
          <FormGroup className="w-100 mt-2">
            <Form.Label>Upload Bus Archive: </Form.Label>
            <FileUploader
              onClear={() => setFieldValue("busArchive", undefined)}
              onChange={(file: any) => {
                setFieldValue("busArchive", file);
              }}
              onBlur={(_: any) => setBusArchiveTouched(true)}
            />
          </FormGroup>
          {errors.busArchive && busArchiveTouched && (
            <ErrorText className="text-danger">Bus archive is required</ErrorText>
          )}
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col className="col-md-10">
          <FormGroup className="w-100 mt-2">
            <Form.Label>Upload Rail Archive: </Form.Label>
            <FileUploader
              onClear={() => setFieldValue("railArchive", undefined)}
              onChange={(file) => {
                setFieldValue("railArchive", file);
              }}
              onBlur={(_) => setRailArchiveTouched(true)}
            />
          </FormGroup>
          {errors.railArchive && railArchiveTouched && (
            <ErrorText className="text-danger">Rail archive is required</ErrorText>
          )}
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col className="col-md-10">
          <FormGroup className="w-100 mt-2">
            <Form.Label>Upload Metro Archive: </Form.Label>
            <FileUploader
              onClear={() => setFieldValue("metroArchive", undefined)}
              onChange={(file: any) => {
                setFieldValue("metroArchive", file);
              }}
              onBlur={(_: any) => setMetroArchiveTouched(true)}
            />
          </FormGroup>
          {errors.metroArchive && metroArchiveTouched && (
            <ErrorText className="text-danger">Metro archive is required</ErrorText>
          )}
        </Col>
      </Row>
    </>
  );
};

export default TranslinkImportFields;
